<div class="child-info">

  <div *ngIf="!ready">
    <se-fe-spinner
      seFeDataSize="950"
      [seFeDataInverted]="false"
      [seFeDataCenter]="true"
    ></se-fe-spinner>
  </div>


  <div role="content" class="child-info-content" *ngIf="ready">
    <se-po-add-child-profile #childInfo></se-po-add-child-profile>

    <div class="form-submit">
      <se-fe-button
        seFeDataEmphasis="high"
        seFeDataType="button"
        (click)="submit()"
        [seFeDataFullWidth]="true"
      >Add Child Profile</se-fe-button>
    </div>
  </div>
</div>
